var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBorrowersIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1411 26.1783L31.9725 23.7088C32.9064 23.207 34.0009 23.4086 34.4526 24.2484C34.9029 25.0883 34.5072 26.1874 33.5734 26.6892L23.5498 32.0618L23.0192 32.1952L13.6702 32.4483C13.6702 32.4483 12.4665 32.7849 11.0203 34.4236",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69995 29.5083L11.9401 25.6047C14.0125 24.207 16.4698 24.9786 16.4698 24.9786C17.6599 25.2924 19.8702 25.3621 19.8702 25.3621H23.5388C24.6318 25.3621 25.5263 26.1429 25.5263 27.0964C25.5263 28.0499 24.6318 28.8307 23.5388 28.8307H18.4634",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7959 22.6687C13.7408 21.174 13.1223 19.3502 13.1223 17.3825C13.1223 14.7963 14.1941 12.4571 15.9147 10.7896",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4919 9.02616C19.6532 8.49557 20.9433 8.19995 22.3031 8.19995C27.374 8.19995 31.4853 12.3113 31.4853 17.3807C31.4853 19.124 31.0002 20.7537 30.1558 22.1423",
    stroke: "#00093A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4348 21.6877C22.0897 21.6877 21.8098 21.4079 21.8098 21.0628V12.9853C21.8098 12.6402 22.0897 12.3604 22.4348 12.3604C22.78 12.3604 23.0598 12.6402 23.0598 12.9853V21.0628C23.0598 21.4079 22.78 21.6877 22.4348 21.6877ZM20.4658 13.4893C20.1541 13.4893 19.9014 13.2366 19.9014 12.9248C19.9014 12.6131 20.1541 12.3604 20.4658 12.3604H22.3609C22.6726 12.3604 22.9254 12.6131 22.9254 12.9248C22.9254 13.2366 22.6726 13.4893 22.3609 13.4893H20.4658Z",
    fill: "#DA291C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowersIcon1);
export default __webpack_public_path__ + "static/media/BorrowersIcon1.62ff4fbf6b7060151383548a9c5a7f85.svg";
export { ForwardRef as ReactComponent };